<template>
    <el-row>
        <el-col :xs="12" :sm="10" :md="8" :lg="8">
            <div class="c-header-title">
                <h1>
                  <router-link :to="{ name: 'home'}">
                    {{ $t("siteTitle") }}<span class="c-header-title__subtitle">{{ $t("siteSubTitle") }}</span>
                  </router-link>
                </h1>
            </div>
        </el-col>
        <el-col :xs="1" :sm="4" :md="8" :lg="10">
            <slot></slot>
        </el-col>
        <el-col :xs="12" :sm="10" :md="8" :lg="6" class="action-buttons">
            <el-button class="top-menu-link">
              <router-link :to="{ name: 'home'}">
                Home
              </router-link>
            </el-button>

          <el-button class="top-menu-link">
              <router-link :to="{ name: 'about'}">
                About me
              </router-link>
            </el-button>

            <div class="c-language-switcher">
                <el-select v-model="locale">
                    <el-option
                        v-for="(lang, i) in langs"
                        :key="`Lang${i}`"
                        :label="langMap[lang]"
                        :value="lang">
                    </el-option>
                </el-select>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    import { LANG_MAP, LANGUAGES } from '@/config/app.config'
    import { setCookie } from '@/services/helpers'

    export default {
        computed: {
            wheelKey() {
                return this.$store.state.wheelKey
            },
        },
        data() {
            return {
                langMap: LANG_MAP,
                langs: LANGUAGES,
                locale: this.initialLang,
            }
        },
        name: 'Header',
        props: [
            'initialLang',
        ],
        watch: {
            locale(val) {
                this.$i18n.locale = val
                this.$store.dispatch('getData', this.$i18n.locale)

                setCookie('wil_lang', val)

                this.$store.commit('updateHome')
                this.$store.commit('updateWheelKey')
                this.$store.commit('updateDescriptionKey')
            },
        },
    }
</script>

<style lang="scss" scoped>
    .c-header-title {
        h1 {
            font-size: 2.2em;
            margin: 0;
            padding: 7px 0;
            color: #353535;
        }
    }

    .c-language-switcher {
        padding: 10px 5px;
        max-width: 110px;
        float: right;

        .el-select .el-input--suffix .el-input__inner {
            border: 0;
        }
    }

    .action-buttons {
      display: flex;
      justify-content: flex-end;
    }

    .top-menu-link {
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 40px;
      line-height: 40px;
      padding: 10px 5px;
      max-width: 110px;
      margin-right: 15px;
    }

    @media (max-width: 1024px) { 
        .c-header-title {
            h1 {
                font-size: 1.8em;
            }
        }
    }

    @media (max-width: 620px) {
      .top-menu-link {
        display: none;
      }
    }

    @media (max-width: 560px) { 
        .c-header-title {
            h1 {
                font-size: 1.2em;
                padding-top: 15px;
            }

            &__subtitle {
                display: none;
            }
        }
    }
</style>
